import type { Box } from "@/components/ui/box.schema";
import type { MaterialLibraryRead } from "@/lib/api/courseMaterials";
import { MaterialBoxes } from "./materials/MaterialBoxes";
import type { CoursePanelHeading } from "./heading-levels";
export function CourseMaterialsPanel({ canEdit, headingLevel: _headingLevel, ...props }: { courseId: string; canEdit: boolean; initialUnitId?: string; initialMaterialId?: string; composeMaterial?: boolean; headingLevel?: CoursePanelHeading; timezone?: string | null; frameBoxes?: Box[]; pageRanking?: MaterialLibraryRead["ranking"] }) {
  return <MaterialBoxes {...props} editable={canEdit} />;
}
